import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import DialogList from 'src/dialogs';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { AnyObject } from 'final-form';

type OfficeOption = {
    id: number,
    office: string
};

interface IGenerateExcelInvoiceListDialogProps {
    dialogName: string;
    handleSubmit?: (payload: AnyObject) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    officeOptions?: Array<OfficeOption>;
}

const GenerateExcelInvoiceListDialog = (props: IGenerateExcelInvoiceListDialogProps) => {
    const [officeOptions, setOfficeOptions] = useState<Array<OfficeOption>>(undefined);
    const { register, handleSubmit } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.officeOptions) {
            setOfficeOptions(props?.officeOptions as unknown as Array<OfficeOption>);
        }
    }, [props?.officeOptions]);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const onSubmit = (data: AnyObject) => {
        const formData = data.generateInvoiceList;
        if (formData) {
            props.handleSubmit(formData);
        }
    };

    return (
        <Dialog title="Generate Excel Invoice List" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                type={'date'}
                                label={'Begin Date:'}
                                name={'generateInvoiceList.begDate'}
                                register={register}
                            />
                            <RHFInputBox
                                type={'date'}
                                label={'End Date:'}
                                name={'generateInvoiceList.endDate'}
                                register={register}
                            />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                            <RHFInputBox
                                label={'Client #:'}
                                name={'generateInvoiceList.clientNumber'}
                                register={register}
                            />
                            <RHFInputBox
                                label={'Project:'}
                                name={'generateInvoiceList.projectNumber'}
                                register={register}
                            />
                        </div>
                        {officeOptions && <RHFSelect
                            labelStyle={{whiteSpace: 'nowrap'}}
                            labelOnLeft={true}
                            label={'Office:'}
                            defaultVal={1}
                            options={Array.isArray(officeOptions) && officeOptions.length > 0 ?
                                officeOptions
                                    ?.filter(oo => oo.office !== 'ALL')
                                    .map((oo, index) => ({
                                        value: index,
                                        label: oo.office ?? ''
                                    })) ?? [] : []} 
                            name={'generateInvoiceList.office'}
                            register={register}
                            style={{width: '100%'}}
                            bodyStyle={{marginTop: '1rem', width: '100%'}}
                            rules={{ required: 'Pay period required' }}
                        />}
                    </div>
                    <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                        <Button
                            className="blue-hover-button"
                            style={{ whiteSpace: 'nowrap', width: '58%', marginRight: '1rem' }}
                            text={'Generate List'}
                            type={'submit'}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default GenerateExcelInvoiceListDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/GenerateExcelInvoiceListDialog.tsx